module.exports = __webpack_public_path__ + "static/2-8198d99492f5b563c1d19e9594e29a67.jpg";